/**
 * Formats an item quantity for customer-facing printed documents.
 *
 * Deliberately separate from `getCleanCurrency` (utils.tsx): that formatter
 * is a MONEY formatter and resolves COP to 0 fraction digits in this
 * runtime's ICU data (see decision #11) — reusing it for quantity silently
 * rounds fractional quantities (e.g. 2.5 -> "3"), which is a document
 * correctness defect, not a cosmetic one. A quantity is always shown with
 * exactly 2 fraction digits regardless of currency formatting rules.
 */
export const formatQuantity = (value: number | string): string =>
  Number(value).toLocaleString("es-CO", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
